import React from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

/** Surface container: white (or dark surface) with a hairline border. */
const Card: React.FC<CardProps> = ({ children, className, ...rest }) => (
  <div className={cn('tw-w-full tw-rounded-2xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-p-4', className)} {...rest}>
    {children}
  </div>
);

export default Card;
